import React from 'react';
import { FileDeliveryRouter } from './index';

export const FileDelivery: React.FC = () => {
  return <FileDeliveryRouter />;
};
